import { Report } from '@mui/icons-material';
import { Link, Stack, Tooltip } from '@mui/material';
import { styles } from 'assets/scss/style-templates';
import TessellLabelValue from 'common/custom-components/lib/components/TessellLabelValue/TessellLabelValue';
import TessellTypographyWithShowMore from 'common/custom-components/lib/components/TessellTypographyWithShowMore';
import { TenantOngoingIssueType } from 'customers/tenants-common-view/lib/schema/Tenant.types';
import { DF_HUMAN } from 'helpers/dateFormats';
import moment from 'moment';

interface TenantOngoingIssueTooltipProps {
  tenantOngoingIssue?: TenantOngoingIssueType;
}

const classes = {
  reportIcon: { color: styles.color.warn },
  valueStyles: { color: styles.color.baseBackground },
  noteStyles: {
    color: styles.color.baseBackground,
    fontSize: '16px',
    fontWeight: 400,
  },
  tooltipPopper: {
    sx: {
      '& .MuiTooltip-tooltip': {
        backgroundColor: styles.color.black,
        color: 'white',
        fontSize: '14px',
        padding: '10px',
        borderRadius: '8px',
        width: '300px',
      },
      '& .MuiTooltip-arrow': {
        color: styles.color.black,
      },
    },
  },
};

const TenantOngoingIssueTooltip = (props: TenantOngoingIssueTooltipProps) => {
  const { tenantOngoingIssue = {} } = props;
  const { note, link, addedBy, lastUpdated } = tenantOngoingIssue;

  return (
    <Stack>
      <Tooltip
        title={
          <Stack gap={1}>
            <Stack>
              <TessellTypographyWithShowMore
                text={note}
                textStyles={classes.noteStyles}
                characterLimit={120}
                showMoreStyles={{ color: styles.color.hover }}
              />
              {link && (
                <Link
                  href={link}
                  target="_blank"
                  color={styles.color.hover}
                  underline="none"
                >
                  More Details
                </Link>
              )}
            </Stack>
            <Stack gap={0.5}>
              <TessellLabelValue
                label="Last Updated"
                value={moment(lastUpdated)?.format(DF_HUMAN)}
                valueStyles={classes.valueStyles}
              />
              <TessellLabelValue
                label="Added By"
                value={addedBy}
                valueStyles={classes.valueStyles}
              />
            </Stack>
          </Stack>
        }
        arrow
        PopperProps={classes.tooltipPopper}
      >
        <Report sx={classes.reportIcon} />
      </Tooltip>
    </Stack>
  );
};

export default TenantOngoingIssueTooltip;
